import { getAssetUrl } from '@/stores/assets'
import { useSelector } from '@/stores/hooks'

export function useAsset(name: string, defaultUrl: string): string
export function useAsset(name: string): string | undefined
export function useAsset(
	name: string,
	defaultUrl?: string,
): string | undefined {
	const url = useSelector(state => getAssetUrl(state, name) ?? defaultUrl)
	if (!url) console.warn(`Asset ${name} not found and no default provided`)
	return url
}
